var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//-----------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import * as THREE from "three";
import { useFrame } from "@react-three/fiber";
// Material ui Imports
import { useEffect, useState } from "react";
// Custom components imports (and hooks and helpers)
import VTCube from "./VTCube";
//---------------------------------------------------------------------------------------------------
// ## COMPONENTS ##
// VTSphere for immersive videos
export default function VTSphere(_a) {
    var video = _a.video, setVideo = _a.setVideo, videoSrc = _a.videoSrc, _b = _a.setVideoCurrentTime, setVideoCurrentTime = _b === void 0 ? function () { } : _b, _c = _a.setVideoCurrentlyPaused, setVideoCurrentlyPaused = _c === void 0 ? function () { } : _c, _d = _a.loading, loading = _d === void 0 ? false : _d;
    //-------------------------------------------------------------------------------------------------
    // ## HOOKS ##
    useFrame(function () {
        setVideoCurrentTime(video.currentTime);
        setVideoCurrentlyPaused(video.paused);
    });
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE, USE MEMO ##
    var _e = __read(useState(false), 2), videoLoaded = _e[0], setVideoLoaded = _e[1];
    //-------------------------------------------------------------------------------------------------
    // ## USE EFFECTS ##
    // Creates the video
    useEffect(function () {
        if (videoSrc) {
            var vid_1 = document.createElement("video");
            vid_1.src = videoSrc;
            vid_1.crossOrigin = "Anonymous";
            vid_1.loop = false;
            vid_1.defaultMuted = true;
            vid_1.autoplay = true;
            // listener to check once loaded
            vid_1.addEventListener("canplay", function () {
                setVideoLoaded(true);
                setVideo(vid_1);
            }, false);
            setVideo(vid_1);
            // Cleanup on leave
            return function () {
                vid_1.pause();
                vid_1.removeAttribute("src"); // empty source
                vid_1.load();
            };
        }
    }, [videoSrc]);
    //-------------------------------------------------------------------------------------------------
    // ## Render ##
    // Returns default cube
    if (videoSrc === undefined) {
        return _jsx(VTCube, {});
    }
    //-------------------------------------------------------------------------------------------------
    // Shows the sphere with the mapped video as a texture
    else if (videoLoaded && !loading) {
        return (_jsxs("mesh", __assign({ rotation: [Math.PI, 0, 0] }, { children: [_jsx("sphereBufferGeometry", { args: [-200, 64, 800] }), _jsx("meshBasicMaterial", { children: _jsx("videoTexture", { encoding: THREE.sRGBEncoding, attach: "map", args: [video] }) })] })));
    }
    //-------------------------------------------------------------------------------------------------
    // Shows loading cube
    else {
        return _jsx(VTCube, { loading: true });
    }
}
